module.exports = __webpack_public_path__ + "static/media/zoom-out-icon.6cf4aab1.svg";